// TOP LEVEL IMPORTS
import React from 'react';
// ANT
import Icon from 'components/common/Icon';

const Bottom = () => {
  return (
    <p style={{ textAlign: 'center', marginTop: 10, color: '#888' }}>
      <Icon type="lock" style={{ fontSize: 13, fontWeight: 600, color: '#666' }} />
      Protected by bank-level security.
      <a target="_blank" href="https://stripe.com/docs/security/stripe">
        {' '}
        Learn More.
      </a>
    </p>
  );
};

export default Bottom;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/Bottom/index.js